export const FIELDS = {

  ID: 'id',
  CODE: 'code',
  DESCRIPTION: 'description',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};